module.exports = __webpack_public_path__ + "static/media/donate.189d647d.gif";